import React, { useState, useEffect } from "react";
import { Mail, Phone, Lock, Eye, EyeOff, ChevronDown } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import logo from "../../image/Larana.png";
import LoadingIndicator from "../../pages/LoadingIndicator";
import Alert from "../../pages/Alert";
import GoogleLoginButton from "../auth/GoogleLoginButton";
import "react-toastify/dist/ReactToastify.css";

// Importation conditionnelle des icônes de réseaux sociaux
const SocialIcons = {
  Google: (props) => (
    <svg viewBox="0 0 24 24" width="24" height="24" {...props}>
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5.01 14.33c-.63 1.43-1.86 2.54-3.41 3.05-1.55.51-3.21.35-4.6-.45-1.39-.8-2.37-2.13-2.7-3.69-.33-1.56.01-3.19.93-4.47-1.01 1.01-1.62 2.4-1.62 3.93 0 3.31 2.69 6 6 6 2.22 0 4.16-1.21 5.2-3l.2-.37z"
      />
    </svg>
  ),
  Facebook: (props) => (
    <svg viewBox="0 0 24 24" width="24" height="24" {...props}>
      <path
        fill="currentColor"
        d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z"
      />
    </svg>
  ),
  X: (props) => (
    <svg viewBox="0 0 24 24" width="24" height="24" {...props}>
      <path
        fill="currentColor"
        d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"
      />
    </svg>
  ),
};

// Liste des indicatifs téléphoniques populaires (la même que dans la page d'inscription)
const countryCodes = [
  { code: "+93", country: "Afghanistan", flag: "🇦🇫" },
  { code: "+355", country: "Albanie", flag: "🇦🇱" },
  { code: "+213", country: "Algérie", flag: "🇩🇿" },
  { code: "+376", country: "Andorre", flag: "🇦🇩" },
  { code: "+244", country: "Angola", flag: "🇦🇴" },
  { code: "+54", country: "Argentine", flag: "🇦🇷" },
  { code: "+374", country: "Arménie", flag: "🇦🇲" },
  { code: "+61", country: "Australie", flag: "🇦🇺" },
  { code: "+43", country: "Autriche", flag: "🇦🇹" },
  { code: "+994", country: "Azerbaïdjan", flag: "🇦🇿" },
  { code: "+1242", country: "Bahamas", flag: "🇧🇸" },
  { code: "+973", country: "Bahreïn", flag: "🇧🇭" },
  { code: "+880", country: "Bangladesh", flag: "🇧🇩" },
  { code: "+32", country: "Belgique", flag: "🇧🇪" },
  { code: "+229", country: "Bénin", flag: "🇧🇯" },
  { code: "+975", country: "Bhoutan", flag: "🇧🇹" },
  { code: "+591", country: "Bolivie", flag: "🇧🇴" },
  { code: "+387", country: "Bosnie-Herzégovine", flag: "🇧🇦" },
  { code: "+267", country: "Botswana", flag: "🇧🇼" },
  { code: "+55", country: "Brésil", flag: "🇧🇷" },
  { code: "+673", country: "Brunei", flag: "🇧🇳" },
  { code: "+359", country: "Bulgarie", flag: "🇧🇬" },
  { code: "+226", country: "Burkina Faso", flag: "🇧🇫" },
  { code: "+257", country: "Burundi", flag: "🇧🇮" },
  { code: "+855", country: "Cambodge", flag: "🇰🇭" },
  { code: "+237", country: "Cameroun", flag: "🇨🇲" },
  { code: "+1", country: "Canada", flag: "🇨🇦" },
  { code: "+238", country: "Cap-Vert", flag: "🇨🇻" },
  { code: "+236", country: "République centrafricaine", flag: "🇨🇫" },
  { code: "+235", country: "Tchad", flag: "🇹🇩" },
  { code: "+56", country: "Chili", flag: "🇨🇱" },
  { code: "+86", country: "Chine", flag: "🇨🇳" },
  { code: "+57", country: "Colombie", flag: "🇨🇴" },
  { code: "+242", country: "Congo", flag: "🇨🇬" },
  { code: "+243", country: "RD Congo", flag: "🇨🇩" },
  { code: "+506", country: "Costa Rica", flag: "🇨🇷" },
  { code: "+225", country: "Côte d'Ivoire", flag: "🇨🇮" },
  { code: "+385", country: "Croatie", flag: "🇭🇷" },
  { code: "+53", country: "Cuba", flag: "🇨🇺" },
  { code: "+357", country: "Chypre", flag: "🇨🇾" },
  { code: "+420", country: "République tchèque", flag: "🇨🇿" },
  { code: "+45", country: "Danemark", flag: "🇩🇰" },
  { code: "+253", country: "Djibouti", flag: "🇩🇯" },
  { code: "+1809", country: "République dominicaine", flag: "🇩🇴" },
  { code: "+593", country: "Équateur", flag: "🇪🇨" },
  { code: "+20", country: "Égypte", flag: "🇪🇬" },
  { code: "+503", country: "El Salvador", flag: "🇸🇻" },
  { code: "+240", country: "Guinée équatoriale", flag: "🇬🇶" },
  { code: "+291", country: "Érythrée", flag: "🇪🇷" },
  { code: "+372", country: "Estonie", flag: "🇪🇪" },
  { code: "+251", country: "Éthiopie", flag: "🇪🇹" },
  { code: "+679", country: "Fidji", flag: "🇫🇯" },
  { code: "+358", country: "Finlande", flag: "🇫🇮" },
  { code: "+33", country: "France", flag: "🇫🇷" },
  { code: "+241", country: "Gabon", flag: "🇬🇦" },
  { code: "+220", country: "Gambie", flag: "🇬🇲" },
  { code: "+995", country: "Géorgie", flag: "🇬🇪" },
  { code: "+49", country: "Allemagne", flag: "🇩🇪" },
  { code: "+233", country: "Ghana", flag: "🇬🇭" },
  { code: "+30", country: "Grèce", flag: "🇬🇷" },
  { code: "+299", country: "Groenland", flag: "🇬🇱" },
  { code: "+502", country: "Guatemala", flag: "🇬🇹" },
  { code: "+224", country: "Guinée", flag: "🇬🇳" },
  { code: "+245", country: "Guinée-Bissau", flag: "🇬🇼" },
  { code: "+592", country: "Guyana", flag: "🇬🇾" },
  { code: "+509", country: "Haïti", flag: "🇭🇹" },
  { code: "+504", country: "Honduras", flag: "🇭🇳" },
  { code: "+852", country: "Hong Kong", flag: "🇭🇰" },
  { code: "+36", country: "Hongrie", flag: "🇭🇺" },
  { code: "+354", country: "Islande", flag: "🇮🇸" },
  { code: "+91", country: "Inde", flag: "🇮🇳" },
  { code: "+62", country: "Indonésie", flag: "🇮🇩" },
  { code: "+98", country: "Iran", flag: "🇮🇷" },
  { code: "+964", country: "Irak", flag: "🇮🇶" },
  { code: "+353", country: "Irlande", flag: "🇮🇪" },
  { code: "+972", country: "Israël", flag: "🇮🇱" },
  { code: "+39", country: "Italie", flag: "🇮🇹" },
  { code: "+1876", country: "Jamaïque", flag: "🇯🇲" },
  { code: "+81", country: "Japon", flag: "🇯🇵" },
  { code: "+962", country: "Jordanie", flag: "🇯🇴" },
  { code: "+7", country: "Kazakhstan", flag: "🇰🇿" },
  { code: "+254", country: "Kenya", flag: "🇰🇪" },
  { code: "+965", country: "Koweït", flag: "🇰🇼" },
  { code: "+996", country: "Kirghizistan", flag: "🇰🇬" },
  { code: "+856", country: "Laos", flag: "🇱🇦" },
  { code: "+371", country: "Lettonie", flag: "🇱🇻" },
  { code: "+961", country: "Liban", flag: "🇱🇧" },
  { code: "+266", country: "Lesotho", flag: "🇱🇸" },
  { code: "+231", country: "Libéria", flag: "🇱🇷" },
  { code: "+218", country: "Libye", flag: "🇱🇾" },
  { code: "+423", country: "Liechtenstein", flag: "🇱🇮" },
  { code: "+370", country: "Lituanie", flag: "🇱🇹" },
  { code: "+352", country: "Luxembourg", flag: "🇱🇺" },
  { code: "+853", country: "Macao", flag: "🇲🇴" },
  { code: "+389", country: "Macédoine du Nord", flag: "🇲🇰" },
  { code: "+261", country: "Madagascar", flag: "🇲🇬" },
  { code: "+265", country: "Malawi", flag: "🇲🇼" },
  { code: "+60", country: "Malaisie", flag: "🇲🇾" },
  { code: "+960", country: "Maldives", flag: "🇲🇻" },
  { code: "+223", country: "Mali", flag: "🇲🇱" },
  { code: "+356", country: "Malte", flag: "🇲🇹" },
  { code: "+222", country: "Mauritanie", flag: "🇲🇷" },
  { code: "+230", country: "Maurice", flag: "🇲🇺" },
  { code: "+52", country: "Mexique", flag: "🇲🇽" },
  { code: "+373", country: "Moldavie", flag: "🇲🇩" },
  { code: "+377", country: "Monaco", flag: "🇲🇨" },
  { code: "+976", country: "Mongolie", flag: "🇲🇳" },
  { code: "+382", country: "Monténégro", flag: "🇲🇪" },
  { code: "+212", country: "Maroc", flag: "🇲🇦" },
  { code: "+258", country: "Mozambique", flag: "🇲🇿" },
  { code: "+95", country: "Myanmar", flag: "🇲🇲" },
  { code: "+264", country: "Namibie", flag: "🇳🇦" },
  { code: "+977", country: "Népal", flag: "🇳🇵" },
  { code: "+31", country: "Pays-Bas", flag: "🇳🇱" },
  { code: "+64", country: "Nouvelle-Zélande", flag: "🇳🇿" },
  { code: "+505", country: "Nicaragua", flag: "🇳🇮" },
  { code: "+227", country: "Niger", flag: "🇳🇪" },
  { code: "+234", country: "Nigeria", flag: "🇳🇬" },
  { code: "+850", country: "Corée du Nord", flag: "🇰🇵" },
  { code: "+47", country: "Norvège", flag: "🇳🇴" },
  { code: "+968", country: "Oman", flag: "🇴🇲" },
  { code: "+92", country: "Pakistan", flag: "🇵🇰" },
  { code: "+970", country: "Palestine", flag: "🇵🇸" },
  { code: "+507", country: "Panama", flag: "🇵🇦" },
  { code: "+675", country: "Papouasie-Nouvelle-Guinée", flag: "🇵🇬" },
  { code: "+595", country: "Paraguay", flag: "🇵🇾" },
  { code: "+51", country: "Pérou", flag: "🇵🇪" },
  { code: "+63", country: "Philippines", flag: "🇵🇭" },
  { code: "+48", country: "Pologne", flag: "🇵🇱" },
  { code: "+351", country: "Portugal", flag: "🇵🇹" },
  { code: "+974", country: "Qatar", flag: "🇶🇦" },
  { code: "+40", country: "Roumanie", flag: "🇷🇴" },
  { code: "+7", country: "Russie", flag: "🇷🇺" },
  { code: "+250", country: "Rwanda", flag: "🇷🇼" },
  { code: "+966", country: "Arabie saoudite", flag: "🇸🇦" },
  { code: "+221", country: "Sénégal", flag: "🇸🇳" },
  { code: "+381", country: "Serbie", flag: "🇷🇸" },
  { code: "+232", country: "Sierra Leone", flag: "🇸🇱" },
  { code: "+65", country: "Singapour", flag: "🇸🇬" },
  { code: "+421", country: "Slovaquie", flag: "🇸🇰" },
  { code: "+386", country: "Slovénie", flag: "🇸🇮" },
  { code: "+252", country: "Somalie", flag: "🇸🇴" },
  { code: "+27", country: "Afrique du Sud", flag: "🇿🇦" },
  { code: "+82", country: "Corée du Sud", flag: "🇰🇷" },
  { code: "+34", country: "Espagne", flag: "🇪🇸" },
  { code: "+94", country: "Sri Lanka", flag: "🇱🇰" },
  { code: "+249", country: "Soudan", flag: "🇸🇩" },
  { code: "+211", country: "Soudan du Sud", flag: "🇸🇸" },
  { code: "+597", country: "Suriname", flag: "🇸🇷" },
  { code: "+268", country: "Eswatini", flag: "🇸🇿" },
  { code: "+46", country: "Suède", flag: "🇸🇪" },
  { code: "+41", country: "Suisse", flag: "🇨🇭" },
  { code: "+963", country: "Syrie", flag: "🇸🇾" },
  { code: "+886", country: "Taïwan", flag: "🇹🇼" },
  { code: "+992", country: "Tadjikistan", flag: "🇹🇯" },
  { code: "+255", country: "Tanzanie", flag: "🇹🇿" },
  { code: "+66", country: "Thaïlande", flag: "🇹🇭" },
  { code: "+228", country: "Togo", flag: "🇹🇬" },
  { code: "+216", country: "Tunisie", flag: "🇹🇳" },
  { code: "+90", country: "Turquie", flag: "🇹🇷" },
  { code: "+993", country: "Turkménistan", flag: "🇹🇲" },
  { code: "+256", country: "Ouganda", flag: "🇺🇬" },
  { code: "+380", country: "Ukraine", flag: "🇺🇦" },
  { code: "+971", country: "Émirats arabes unis", flag: "🇦🇪" },
  { code: "+44", country: "Royaume-Uni", flag: "🇬🇧" },
  { code: "+1", country: "États-Unis", flag: "🇺🇸" },
  { code: "+598", country: "Uruguay", flag: "🇺🇾" },
  { code: "+998", country: "Ouzbékistan", flag: "🇺🇿" },
  { code: "+58", country: "Venezuela", flag: "🇻🇪" },
  { code: "+84", country: "Vietnam", flag: "🇻🇳" },
  { code: "+967", country: "Yémen", flag: "🇾🇪" },
  { code: "+260", country: "Zambie", flag: "🇿🇲" },
  { code: "+263", country: "Zimbabwe", flag: "🇿🇼" },
];

const BackendUrl = process.env.REACT_APP_Backend_Url;

const Connexion = ({ chg }) => {
  // États du formulaire
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    phoneNumber: "",
    countryCode: "+227", // Par défaut Niger comme dans la page d'inscription
    rememberMe: false,
  });

  // États de l'interface
  const [showPassword, setShowPassword] = useState(false);
  const [loginMethod, setLoginMethod] = useState("email");
  const [isloading, setIsloading] = useState(false);
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);

  // États des alertes
  const [alert, setAlert] = useState({
    visible: false,
    type: "",
    message: "",
  });

  const navigate = useNavigate();
  const location = useLocation();

  // Validations regex
  const regexMail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const regexPhone = /^[0-9]{8,}$/; // Même validation que dans inscription

  // Gestionnaire de changement pour tous les champs du formulaire
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Fermer le dropdown d'indicatif si on clique ailleurs
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showCountryDropdown && !event.target.closest(".country-dropdown")) {
        setShowCountryDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCountryDropdown]);

  // Fonctions pour les alertes
  const showAlert = (type, message) => {
    setAlert({ visible: true, type, message });
    setTimeout(() => {
      setAlert({ visible: false, type: "", message: "" });
    }, 5000);
  };

  const handleSuccess = (message) => showAlert("success", message);
  const handleWarning = (message) => showAlert("warn", message);

  // Navigation basée sur les paramètres d'URL
  const navigateBasedOnLocation = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const destinations = {
      fromCart: "/panier",
      fromProfile: "/Compte",
      fromMore: "/More",
      fromMessages: "/Messages",
    };

    for (const [key, path] of Object.entries(destinations)) {
      if (urlParams.get(key)) {
        navigate(`${path}?${key}=true`);
        return;
      }
    }
    navigate("/Home");
  };

  // Changement de méthode de connexion
  const switchLoginMethod = (method) => {
    setLoginMethod(method);
    setFormData((prev) => ({
      ...prev,
      email: method === "email" ? prev.email : "",
      phoneNumber: method === "phone" ? prev.phoneNumber : "",
    }));
  };

  // Fonction de connexion
  const handleLogin = async (e) => {
    e.preventDefault();
    const { email, password, phoneNumber, countryCode, rememberMe } = formData;
    setIsloading(true);

    // Validation des champs
    if (loginMethod === "email" && email && !regexMail.test(email)) {
      handleWarning("Veuillez entrer une adresse e-mail valide.");
      setIsloading(false);
      return;
    }

    if (
      loginMethod === "phone" &&
      phoneNumber &&
      (!regexPhone.test(phoneNumber) || phoneNumber.length > 11)
    ) {
      handleWarning("Veuillez entrer un numéro de téléphone valide.");
      setIsloading(false);
      return;
    }

    if (!password || password.length < 6) {
      handleWarning("Votre mot de passe doit contenir au moins 6 caractères.");
      setIsloading(false);
      return;
    }

    // Formater le numéro de téléphone avec l'indicatif pays
    const formattedPhoneNumber =
      loginMethod === "phone" ? `${countryCode}${phoneNumber}` : null;

    // Données de connexion
    const loginData = {
      email: loginMethod === "email" && email.length > 0 ? email : null,
      phoneNumber:
        loginMethod === "phone" && phoneNumber.length > 0
          ? formattedPhoneNumber
          : null,
      password: password,
    };

    try {
      const response = await axios.post(
        `${BackendUrl}/api/user/login`,
        loginData,
        {
          withCredentials: true,
          credentials: "include",
        }
      );

      if (response.status === 200) {
        handleSuccess(response.data.message);
        setIsloading(false);

        // Réinitialisation du formulaire
        setFormData({
          email: "",
          password: "",
          phoneNumber: "",
          countryCode: "+227",
          rememberMe: false,
        });

        // Stockage de l'utilisateur et redirection
        localStorage.setItem("userEcomme", JSON.stringify(response.data));
        chg("oui");
        navigateBasedOnLocation();
      } else {
        handleWarning(response.data.message);
        setIsloading(false);
      }
    } catch (error) {
      console.error("Erreur de connexion:", error);
      handleWarning(
        error.response && error.response.status === 400
          ? error.response.data.message
          : "Une erreur s'est produite lors de la connexion. Veuillez réessayer."
      );
      setIsloading(false);
    }
  };

  // Affichage du chargement
  if (isloading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-center">
          <h1 className="text-xl font-semibold mb-4">
            Connexion en cours, veuillez patienter...
          </h1>
          <LoadingIndicator loading={isloading} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-50">
      <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-xl shadow-lg">
        <div className="text-center">
          <img src={logo} alt="Logo" className="mx-auto w-24 h-24" />
          <h2 className="mt-6 text-3xl font-bold text-[#008751] uppercase">
            Connexion
          </h2>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          {/* Sélecteur de méthode de connexion */}
          <div>
            <div className="flex justify-center space-x-4 mb-4">
              <button
                type="button"
                onClick={() => switchLoginMethod("email")}
                className={`px-4 py-2 rounded-full transition-colors ${
                  loginMethod === "email"
                    ? "bg-[#008751] text-white"
                    : "bg-gray-200 hover:bg-gray-300"
                }`}
              >
                Email
              </button>
              <button
                type="button"
                onClick={() => switchLoginMethod("phone")}
                className={`px-4 py-2 rounded-full transition-colors ${
                  loginMethod === "phone"
                    ? "bg-[#008751] text-white"
                    : "bg-gray-200 hover:bg-gray-300"
                }`}
              >
                Téléphone
              </button>
            </div>

            {/* Champ Email */}
            {loginMethod === "email" && (
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Adresse email
                </label>
                <div className="mt-1 relative rounded-md shadow-sm">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <Mail className="h-5 w-5 text-gray-400" />
                  </div>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-[#008751] focus:border-[#008751] sm:text-sm"
                    placeholder="vous@exemple.com"
                  />
                </div>
              </div>
            )}

            {/* Champ téléphone avec indicatif pays */}
            {loginMethod === "phone" && (
              <div>
                <label
                  htmlFor="phoneNumber"
                  className="block text-sm font-medium text-gray-700"
                >
                  Numéro de téléphone
                </label>
                <div className="mt-1 flex rounded-md shadow-sm">
                  {/* Indicatif pays */}
                  <div className="relative country-dropdown">
                    <button
                      type="button"
                      className="relative inline-flex items-center px-3 py-2 border border-r-0 border-gray-300 rounded-l-md bg-gray-50 text-sm font-medium text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-[#008751] focus:border-[#008751]"
                      onClick={() =>
                        setShowCountryDropdown(!showCountryDropdown)
                      }
                    >
                      <span>
                        {
                          countryCodes.find(
                            (c) => c.code === formData.countryCode
                          )?.flag
                        }{" "}
                        {formData.countryCode}
                      </span>
                      <ChevronDown className="ml-1 h-4 w-4" />
                    </button>
                    {showCountryDropdown && (
                      <div className="absolute z-10 mt-1 w-56 bg-white shadow-lg max-h-60 rounded-md py-1 ring-1 ring-black ring-opacity-5 overflow-auto">
                        {countryCodes.map((country) => (
                          <div
                            key={country.code}
                            className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                            onClick={() => {
                              setFormData((prev) => ({
                                ...prev,
                                countryCode: country.code,
                              }));
                              setShowCountryDropdown(false);
                            }}
                          >
                            <span className="mr-2">{country.flag}</span>
                            <span>{country.country}</span>
                            <span className="ml-auto">{country.code}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Champ numéro */}
                  <div className="relative flex-1">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Phone className="h-5 w-5 text-gray-400" />
                    </div>
                    <input
                      id="phoneNumber"
                      name="phoneNumber"
                      type="tel"
                      required
                      value={formData.phoneNumber}
                      onChange={(e) => {
                        // Ne permet que les chiffres
                        const value = e.target.value.replace(/\D/g, "");
                        setFormData((prev) => ({
                          ...prev,
                          phoneNumber: value,
                        }));
                      }}
                      className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-r-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-[#008751] focus:border-[#008751] sm:text-sm"
                      placeholder="Numéro sans indicatif"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Champ mot de passe */}
          <div>
            <div className="flex justify-between items-center">
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700"
              >
                Mot de passe
              </label>
              <div className="text-sm">
                <span
                  onClick={() => navigate("/Forget Password")}
                  className="font-medium text-[#008751] hover:text-[#006b3c] cursor-pointer"
                >
                  Mot de passe oublié ?
                </span>
              </div>
            </div>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Lock className="h-5 w-5 text-gray-400" />
              </div>
              <input
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                required
                value={formData.password}
                onChange={handleChange}
                className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-[#008751] focus:border-[#008751] sm:text-sm"
                placeholder="Votre mot de passe"
              />
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500"
                >
                  {showPassword ? (
                    <Eye className="h-5 w-5" />
                  ) : (
                    <EyeOff className="h-5 w-5" />
                  )}
                </button>
              </div>
            </div>
          </div>

          {/* Option se souvenir de moi */}
          <div className="flex items-center">
            <input
              id="rememberMe"
              name="rememberMe"
              type="checkbox"
              checked={formData.rememberMe}
              onChange={handleChange}
              className="h-4 w-4 text-[#008751] focus:ring-[#008751] border-gray-300 rounded"
            />
            <label
              htmlFor="rememberMe"
              className="ml-2 block text-sm text-gray-900"
            >
              Se souvenir de moi
            </label>
          </div>

          {/* Bouton de connexion */}
          <div>
            <button
              type="submit"
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#008751] hover:bg-[#006b3c] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#008751] transition-colors"
            >
              Se connecter
            </button>
          </div>
        </form>

        {/* Séparateur */}
        <div className="relative">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-300"></div>
          </div>
          <div className="relative flex justify-center text-sm">
            <span className="px-2 bg-white text-gray-500">
              Ou continuez avec
            </span>
          </div>
        </div>

        {/* Bouton Google */}
        <GoogleLoginButton text="Continuer avec Google" />

        {/* Lien d'inscription */}
        <p className="text-center text-sm text-gray-500">
          Pas encore membre ?{" "}
          <span
            onClick={() => navigate("/Inscription")}
            className="font-medium text-[#008751] hover:text-[#006b3c] cursor-pointer"
          >
            Inscrivez-vous maintenant
          </span>
        </p>
      </div>

      {/* Alertes */}
      {alert.visible && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert({ visible: false })}
        />
      )}
    </div>
  );
};

export default Connexion;
